var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhotoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.607 5.50061H15.309C9.27898 5.50061 5.50098 9.76861 5.50098 15.8086V32.1066C5.50098 38.1466 9.26298 42.4146 15.309 42.4146H32.605C38.653 42.4146 42.415 38.1466 42.415 32.1066V15.8086C42.415 9.76861 38.653 5.50061 32.607 5.50061Z",
    stroke: "#6C5DD3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4064 17.571C21.4064 19.609 19.7524 21.263 17.7144 21.263C15.6784 21.263 14.0244 19.609 14.0244 17.571C14.0244 15.533 15.6784 13.879 17.7144 13.879C19.7524 13.879 21.4064 15.533 21.4064 17.571Z",
    stroke: "#6C5DD3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.414 29.9011C40.426 28.1711 38.696 26.0891 36.416 24.7151C34.132 23.3411 31.678 24.1891 30.094 26.2391C28.564 28.2211 27.608 30.8871 25.298 32.1371C22.452 33.6791 20.78 31.1931 18.406 30.1971C15.756 29.0871 13.744 31.0831 12.196 33.0011C10.646 34.9211 9.076 36.8211 7.5 38.7211",
    stroke: "#6C5DD3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoIcon);
export default __webpack_public_path__ + "static/media/photo-icon.c4181a1d6f6691a5a97f65cae7699a78.svg";
export { ForwardRef as ReactComponent };